import { Dispatch } from 'redux';

import { IBuilderSaveResult } from 'components/EmbeddedBuilder';
import { rewardCreate } from 'containers/Reward/actions';
import { getPreparedData } from 'containers/Reward/utils';

import { ConfigIntent } from '../configStudio/configSubmission';
import { RewardFormValues } from './rewardAdapter';

const FALLBACK = 'Something went wrong. Please try again later.';

interface IRewardCreateResponse {
  data?: { id?: number };
  meta?: { reward_request_id?: number };
}

// `rewardCreate` navigates to the new reward through this; inside Orbit the host decides instead.
const stayInOrbit = () => undefined;

/**
 * Creates the reward through the module's own action (`rewardCreate`, `POST /v4/dash/rewards`,
 * as `pages/reward/create.tsx`, draft = `is_draft: true`). Its middleware shows the module's
 * toasts; `meta.reward_request_id` marks a maker-checker request. Rejects with the API's message,
 * which the review shows inline.
 */
export const saveReward = (
  dispatch: Dispatch,
  values: RewardFormValues,
  intent: ConfigIntent
): Promise<IBuilderSaveResult> =>
  new Promise((resolve, reject) => {
    const prepared = getPreparedData(intent === 'draft' ? { is_draft: true, ...values } : values);
    dispatch(
      rewardCreate(
        prepared,
        (response?: IRewardCreateResponse, failure?: { message?: string }) => {
          const id = response?.data?.id;
          if (id === undefined) {
            reject(new Error(failure?.message || FALLBACK));
            return;
          }
          resolve({
            entity: 'reward',
            id,
            pendingRequestId: response?.meta?.reward_request_id ?? null,
            savedAsDraft: intent === 'draft'
          });
        },
        stayInOrbit
      )
    );
  });
